import domReady from 'domready';
import search from './frontpage-search';
import mobileModalWrapper from './mobile-modal-wrapper';
import '../styles.css';

function globalSearch(ele, baseUrl, isMobile, isGlobal) {
    if (isGlobal) {
        const inputEle = document.getElementById('search');
        inputEle.addEventListener('input', () => {
            const url = new URL(document.baseURI);
            url.searchParams.set(inputEle.name, inputEle.value);
            window.history.replaceState(window.history.state, '', url.href);
        });
    }

    if (!isMobile) {
        const input = document.getElementById('search');
        const yPos = window.pageYOffset || document.documentElement.scrollTop;
        if (yPos < 100) {
            input.focus();
        }
    }

    const searchUrl = `${baseUrl}/search/front`;
    const streamSuggestUrl = `${searchUrl}/streamingsuggest`;
    const suggestUrl = `${searchUrl}/suggest`;
    // TODO: Client should be MFINN for now to keep the same behavior. Should probably change in the future
    // AdOut will handle this
    const client = 'MFINN';

    if (isMobile && !isGlobal) {
        mobileModalWrapper(ele, wrappedEle =>
            search(wrappedEle, streamSuggestUrl, suggestUrl, client)
        );
    } else {
        search(ele, streamSuggestUrl, suggestUrl, client);
    }
}

export const globalSearchMobile = (ele, baseUrl) => globalSearch(ele, baseUrl, true);
export const globalSearchDesktop = (ele, baseUrl) => globalSearch(ele, baseUrl, false);

domReady(() => {
    const ele = document.getElementById('global-search');
    const baseUrl = ele.getAttribute('data-base-url') || 'https://www.finn.no';
    globalSearch(ele, baseUrl, ele.getAttribute('data-is-mobile') === 'true', ele.hasAttribute('data-global'));
});
